import PropTypes from 'prop-types';

import { TYPE_STORY } from '@/lib/scheduler/postType';
import {
    FACEBOOK,
    INSTAGRAM,
    LINKEDIN,
    PINTEREST,
    THREADS,
    TIKTOK_BUSINESS,
    TWITTER,
    X
} from '@/lib/socialProfile';

import { FacebookCaption } from '@/components/composite/Caption/Facebook';
import { GenericCaption } from '@/components/composite/Caption/Generic';
import { LinkedinCaption } from '@/components/composite/Caption/Linkedin/CaptionWithMention';
import { ThreadsCaption } from '@/components/composite/Caption/Threads';
import { TiktokBusinessCaption } from '@/components/composite/Caption/TiktokBusiness';
import { XCaption } from '@/components/composite/Caption/X';
import { AiCaption } from '@/components/composite/Scheduler/PostFunnel/SchedulerCaption/AiCaption';
import { CaptionRendering } from '@/components/composite/Scheduler/PostFunnel/SchedulerCaption/CaptionRendering';

export const SchedulerCaptionContent = ({ network, type, ...restProps }) => {
    switch (network) {
        case INSTAGRAM:
            if (type === TYPE_STORY) {
                return null;
            }
            return <GenericCaption {...restProps} />;
        case FACEBOOK:
            return <FacebookCaption {...restProps} />;
        case PINTEREST:
            return <GenericCaption {...restProps} />;
        case X:
            return <XCaption {...restProps} />;
        case LINKEDIN:
            return <LinkedinCaption {...restProps} />;
        case TIKTOK_BUSINESS:
            return <TiktokBusinessCaption {...restProps} />;
        case THREADS:
            return <ThreadsCaption {...restProps} />;
        default:
            return null;
    }
};

export const SchedulerCaption = ({
    network,
    type,
    captionLayoutConfig = { hasBorder: true, hasAvatar: true, label: null, aiButton: false },
    aiConfig,
    ...restProps
}) => {
    if (type === TYPE_STORY) {
        return null;
    }
    return (
        <>
            <div className="flex w-full flex-col">
                <div className="flex w-full items-center justify-between">
                    {captionLayoutConfig?.label}

                    {captionLayoutConfig?.aiButton ? (
                        <AiCaption
                            updateCaption={aiConfig.updateCaption}
                            hasPreviousAction={aiConfig.hasPreviousAction}
                            previousCallback={aiConfig.previousCallback}
                            clearError={aiConfig.clearError}
                            currentCaption={aiConfig.currentCaption}
                            currentProfileId={aiConfig.currentProfileId}
                            isButtonDisabled={aiConfig.isButtonDisabled}
                            dropdownCallbacks={aiConfig.dropdownCallbacks}
                        />
                    ) : null}
                </div>
                <CaptionRendering
                    currentAction={aiConfig?.currentAiAction}
                    error={aiConfig?.aiActionError}>
                    <SchedulerCaptionContent
                        network={network}
                        type={type}
                        captionLayoutConfig={{ ...captionLayoutConfig, label: null }}
                        {...restProps}
                    />
                </CaptionRendering>
            </div>
        </>
    );
};

SchedulerCaption.propTypes = {
    network: PropTypes.oneOf([
        INSTAGRAM,
        FACEBOOK,
        LINKEDIN,
        TWITTER,
        X,
        TIKTOK_BUSINESS,
        PINTEREST,
        THREADS
    ]),
    type: PropTypes.string
};
